<ngx-app-bar
  class="w-100"
  [title]="'انتخاب روش سرمایه‌گذاری'"
  [rightButton]="{
    icon: 'arrow-right',
    style: 'neutral-link',
    mode: 'icon-only',
    size: 'medium',
  }"
  (onRightButtonClick)="onBackHandler()"
/>

<div class="w-100 d-flex flex-wrap container">
  <p class="title">یکی از روش‌های زیر را برای سرمایه‌گذاری انتخاب کنید :</p>

  <div class="w-100 payment-methods">
    @for (method of paymentMethods; track method; let i = $index) {
      <div
        class="method"
        (click)="updateSelectedMethod(method)"
      >
        <div class="title">
          <span>
            {{ method.title }}
          </span>

          <div
            class="selection"
            [ngClass]="{ selected: method.selected }"
          ></div>
        </div>

        <div class="description">
          <span>
            {{ method.description }}
          </span>
        </div>
      </div>
    }
  </div>
</div>

<div class="button-container">
  <ngx-button
    [style]="'fill'"
    [fullWidth]="true"
    (clickHandler)="continue()"
    [size]="'medium'"
    [buttonId]="'IPO_CHOICE_PAYMENT_' + selectedMethod.id"
  >
    تایید و ادامه
  </ngx-button>
</div>
